import { gql, TypedDocumentNode } from '@common/hooks';
import {
  BillingCardQueryCgResponse,
  BillingCardQueryVariables,
} from '@common/graphql';

export const BillingCardProgressQuery: TypedDocumentNode<
  BillingCardQueryCgResponse,
  BillingCardQueryVariables
> = gql`
  query BillingCard($id: ID!) {
    billingCard(id: $id) {
      id
      pending
      progress
      totalEntitiesAssociated
    }
  }
`;
